import React from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';

const calcPercent = (num, total) => (num * 100) / total;

const SunburstTooltip = (
  parentValue,
  parentName,
  { id, node, parent, value, name, series },
  isPaying,
  data,
  single
) => {
  // т.к. возможен случай, когда при флаге single=true (по умолчанию) имеется только одно событие, для отрабатывания простого тултипа
  // проверяем не только флаг single, но и колличество событий в данных.
  if (!single || data.length === 1) {
    return ReactDOMServer.renderToStaticMarkup(
      <div>
        <span className="tooltip-bold">{name}</span>
        <br />
        Value: <span className="tooltip-bold">{`${_.round(value, 2)}${isPaying ? '%' : ''}`}</span>
        {node.sliced === undefined && node.level !== 1 ? (
          <>
            <br />
            is <span className="tooltip-bold">{_.round(calcPercent(value, parentValue), 2)}% </span>
            <br />
            of {parentName} of:{' '}
            <span className="tooltip-bold">
              {`${_.round(parentValue, 2)}${isPaying ? '%' : ''}`}
            </span>
          </>
        ) : undefined}
      </div>
    );
  }

  let splitInfo = ``;

  if (node.level >= 3) {
    const parentItem = series.data.find((item) => item.id === parent);
    const rootItem = series.data.find((item) => item.id === parentItem.parent);

    splitInfo = `${rootItem.id}.${rootItem.name}.${parentItem.name}`;
  }

  switch (node.level) {
    case 1:
      return ReactDOMServer.renderToStaticMarkup(
        <div>
          <span className="tooltip-bold">{`${id}.${name}`}</span>
          <br />
          Value:{' '}
          <span className="tooltip-bold">{`${_.round(value, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
      );

    case 2:
      return ReactDOMServer.renderToStaticMarkup(
        <div>
          <span className="tooltip-bold">{name}</span>
          <br />
          <span className="tooltip-bold">{`${parent}.${parentName}`}</span>
          <br />
          Value:{' '}
          <span className="tooltip-bold">{`${_.round(value, 2)}${isPaying ? '%' : ''}`}</span>
          <br />
          is <span className="tooltip-bold">{_.round(calcPercent(value, parentValue), 2)}% </span>
          <br />
          of {`${parent}.${parentName}`} of:{' '}
          <span className="tooltip-bold">{`${_.round(parentValue, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
      );

    default:
      return ReactDOMServer.renderToStaticMarkup(
        <div>
          <span className="tooltip-bold">{name}</span>
          <br />
          <span className="tooltip-bold">{`${splitInfo}`}</span>
          <br />
          Value:{' '}
          <span className="tooltip-bold">{`${_.round(value, 2)}${isPaying ? '%' : ''}`}</span>
          <br />
          is <span className="tooltip-bold">{_.round(calcPercent(value, parentValue), 2)}% </span>
          <br />
          of {`${splitInfo}`} of:{' '}
          <span className="tooltip-bold">{`${_.round(parentValue, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
      );
  }
};

export default SunburstTooltip;
